import {
  dashboardPathForSection,
  dashboardSectionFromPathSegment,
  defaultDashboardContentType,
} from "@dashboard/routes/dashboard-navigation"
import { LazyDashboardApp } from "@dashboard/routes/lazy-dashboard-app"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { DashboardShellSkeleton } from "@ui-dashboard/DashboardShellSkeleton"
import { dashboardAppHostRedirectUrl } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"
import { Suspense } from "react"

export const Route = createFileRoute("/dashboard/$section")({
  component: DashboardSectionRoute,
  beforeLoad: async ({ location, params }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })

    const section = dashboardSectionFromPathSegment(params.section)
    if (!section) {
      throw redirect({ href: dashboardPathForSection(defaultDashboardContentType) })
    }
  },
})

function DashboardSectionRoute() {
  const { section } = Route.useParams()
  const dashboardSection = dashboardSectionFromPathSegment(section) ?? defaultDashboardContentType

  return (
    <Suspense fallback={<DashboardShellSkeleton />}>
      <LazyDashboardApp activeSection={dashboardSection} />
    </Suspense>
  )
}
